mutation BatchEditApprovalCreate($input: BatchEditApprovalCreateInput!) {
  batchEditApprovalCreate(input: $input) {
    approvalRequestResults {
      _status
      _isSubmitted
      entityId
    }
  }
}
